import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { NavigationBar } from "./NavigationBar";
import { NaviMenu } from "./NaviMenu";
import { NonAuthNaviMenu } from "./NonAuthNaviMenu";
import { Row, Col, Container } from "react-bootstrap";
import { Facebook, Youtube } from 'react-bootstrap-icons';

export const PageLayout = (props) => {
    return (
        <>
            <NavigationBar />

            <AuthenticatedTemplate>
                <NaviMenu />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <NonAuthNaviMenu />
            </UnauthenticatedTemplate>
            <div style={{ marginTop: '50px' , marginBottom: '100px'}}>
                {props.children}
            </div>

            {/* footerはクラス分割したい */}
            <footer className="bg-light text-lg-start text-muted" style={{ fontSize: '11px', fontWeight: 'bold' }}>
                <section className='pt-3'>
                    <Container>
                        <Row>
                            <Col sm={8}>
                                <div className='text-right p-2 footer__sitemap'>
                                    <span>Site Map</span><br />
                                </div>
                                <ul className='text-right p-2 list-group list-group-flush footerNav__list'>
                                    <li className="list-group-item fotterNav__item ps-0"><a className='footerNav__link' rel="noopener" href='/'>HOME</a></li>
                                    <li className="list-group-item fotterNav__item ps-0"><a className='footerNav__link' rel="noopener" href='/'>Contact</a></li>
                                    <li className="list-group-item fotterNav__item ps-0"><a className='footerNav__link' rel="noopener" href='/'>HOGE</a></li>
                                    <li className="list-group-item fotterNav__item ps-0"><a className='footerNav__link' rel="noopener" href='/'>FUGA</a></li>
                                </ul>
                            </Col>
                            <Col sm={4}>
                                <div className='text-right p-2'>
                                    <span>OFFICIAL SNS ACCOUNT</span><br /><br />
                                    <a href='https://www.facebook.com/alive0309/?locale=ja_JP' className='me-4 text-reset'>
                                        <Facebook size={20} />
                                    </a>
                                    <a href='https://www.youtube.com/@alive_project4913' className='me-4 text-reset'>
                                        <Youtube size={20} />
                                    </a>
                                </div>
                                <div className="text-right p-2">
                                    <span>団体名 一般社団法人ALIVE</span><br />
                                    <span>設立　2017年3月9日</span><br />
                                    <span>住所　東京都豊島区南大塚3-36-7　南大塚T&Tビル6F</span>
                                </div>
                                <div className='text-right p-2' >
                                    ©Copyright© Alive All Rights Reserved.
                                    <a className='text-reset fw-bold' href='https://alive0309.org/'>
                                        ALIVE0309.org
                                    </a>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </footer>
        </>
    );
}